module.exports = __webpack_public_path__ + "static/media/09_1440.f357ddfb.jpeg";